import { render } from "./IndividualDisplay.vue?vue&type=template&id=71f37a80&scoped=true"
import script from "./IndividualDisplay.vue?vue&type=script&lang=ts"
export * from "./IndividualDisplay.vue?vue&type=script&lang=ts"

import "./IndividualDisplay.vue?vue&type=style&index=0&id=71f37a80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-71f37a80"

export default script